import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const CreacionProduccionApi = () => {
    const [cargando, setCargando] = useState(false);

    const crearProduccion = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("produccion_v2", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getSiguienteNumeroProduccion = async (params) => {
        try {
            setCargando(true);

            const response = await api.get(
                "produccion_v2/siguiente_numero",
                params,
            );
            return response.numero;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        crearProduccion,
        getSiguienteNumeroProduccion,

        cargando,
    };
};
